import { alpha, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

export interface DotLegalTableWithControlsStyleProps {
    clickableRows?: boolean;
    hideRowsPerPage?: boolean;
}

export const useDotLegalTableWithControlsStyles = makeStyles((theme: Theme) => ({
    controlsRow: (props: DotLegalTableWithControlsStyleProps) => ({
        display: "flex",
        justifyContent: props.hideRowsPerPage ? "flex-end" : "space-between",
    }),
    table: (props: DotLegalTableWithControlsStyleProps) => ({
        "& th": {
            borderBottom: "none",
            ...theme.typography.h5,
            padding: `${theme.spacing(1)} 0`,
        },
        "& tbody tr": {
            height: 48,
            cursor: props.clickableRows === false ? "default" : "pointer",
        },
        "& tbody tr:hover": {
            backgroundColor: props.clickableRows === false ? undefined : theme.palette.primary.light,
        },
        "& .MuiTableSortLabel-icon": {
            fill: theme.palette.primary.main,
        },
        "& tbody .MuiTableCell-root": {
            borderColor: alpha(theme.palette.primary.main, 0.65),
        },
    }),
    emptyText: {
        marginTop: theme.spacing(1),
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.grey[400],
    },
    paginationLabel: {
        alignSelf: "center",
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.text.disabled,
        marginTop: theme.spacing(0.6),
    },
}));

export default useDotLegalTableWithControlsStyles;
